// DS: MO0.8
import React from 'react';
import classnames from 'classnames';
import { Url } from '@wix/da-url';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import type { BiEvent } from '@wix/da-bi/pkg/events';
import { useTranslation } from 'react-i18next';
import Points from '@wix/da-ds/pkg/Icons/Points';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { formatDollars } from '../utils/formatting';
import s from './PointsCard.scss';

interface Props {
  pointsAmount: number;
  price: number;
  subproductId: number;
  isPopular?: boolean;
  className?: string;
  biData?: BiEvent;
}

const PointsCard: React.FC<Props> = ({
  pointsAmount,
  price,
  subproductId,
  isPopular,
  className,
  biData,
}) => {
  const { t } = useTranslation();
  return (
    <Section
      className={classnames(s['root'], isPopular && s['popular'], className)}
    >
      <span className={s['popular-note']}>{t('common.points.popular')}</span>
      <Heading className={s['points-root']}>
        <span className={s['points-amount']}>
          <Points size={IconSize.MEDIUM} />
          {Intl.NumberFormat('en-US').format(pointsAmount)}
        </span>
        <span className={s['points-label']}>{t('common.points')}</span>
      </Heading>
      <SolidButton
        size="large"
        variant="approval-green"
        className={s['cta']}
        href={Url.checkoutLink(subproductId)}
        biData={biData}
      >
        {formatDollars(`${price}`)}
      </SolidButton>
    </Section>
  );
};

PointsCard.displayName = 'PointsCard';

export default PointsCard;
